export const name = "SAFE_DIVIDE";
export const summary = `Equivalent to the division operator (\`X / Y\`), but returns \`NULL\` if an error occurs.`;
export const reference = `
## SAFE_DIVIDE

Equivalent to the division operator (\`X / Y\`), but returns \`NULL\` if an error occurs.

\`\`\`
SAFE_DIVIDE(X, Y)
\`\`\`

### Description

Equivalent to the division operator (\`X / Y\`), but returns\`NULL\` if an error occurs, such as a division by zero error.

| X | Y | SAFE\\_DIVIDE(X, Y) |
| --- | --- | --- |
| 20 | 4 | 5 |
| 0 | 20 | \`0\` |
| 20 | 0 | \`NULL\` |


### Return Data Type

| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| --- | --- | --- | --- | --- |
| \`INT64\` | \`FLOAT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| \`NUMERIC\` | \`NUMERIC\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| \`FLOAT64\` | \`FLOAT64\` | \`FLOAT64\` | \`FLOAT64\` | \`FLOAT64\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
